// CrewMagic dashboard entrypoint. Mounts the React root inside
// #crew-magic-root in app/views/layouts/application.html.haml.

import "../crew_magic/styles/application.css"
import { mount } from "../crew_magic/main"

document.addEventListener("DOMContentLoaded", () => {
  const el = document.getElementById("crew-magic-root")
  if (el) mount(el)
})
